module.exports = __webpack_public_path__ + "media/img/vca/nomg1-96dc83a4e156ceca9601ffd1668c60c2.png";